import React, { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import useProductStore from './stores/useProductStore';
import GraphicProductData from './GraphicProductData';

const selectPanelData = (s) => ({
  product: s.product,
  productFields: s.productFields,
  feedPage: s.feedPage,
  feedPageIndex: s.feedPageIndex,
  productIndex: s.productIndex,
  reloadingProducts: s.reloadingProducts,
  toPrevProduct: s.toPrevProduct,
  toNextProduct: s.toNextProduct,
  toSelectProduct: s.toSelectProduct,
  toFeedPageSelect: s.toFeedPageSelect,
  searchProductById: s.searchProductById,
});

const GraphicProductDataPanel = ({ onClose, onDraggingElementFinish, style }) => {
  const {
    product,
    productFields,
    feedPage,
    feedPageIndex,
    productIndex,
    reloadingProducts,
    toPrevProduct,
    toNextProduct,
    toSelectProduct,
    toFeedPageSelect,
    searchProductById,
  } = useProductStore(useShallow(selectPanelData));

  const resetProductSearch = useCallback(() => {
    const s = useProductStore.getState();
    s.clearFeedListQuery();
    void s.loadFeed();
  }, []);

  return (
    <GraphicProductData
      inGraphicEditor
      product={product}
      productFields={productFields}
      feedPage={feedPage}
      feedPageIndex={feedPageIndex}
      productIndex={productIndex}
      reloadingProducts={reloadingProducts}
      searchProductById={searchProductById}
      resetProductSearch={resetProductSearch}
      toPrevProduct={toPrevProduct}
      toNextProduct={toNextProduct}
      toSelectProduct={toSelectProduct}
      toFeedPageSelect={toFeedPageSelect}
      onClose={onClose}
      onDraggingElementFinish={onDraggingElementFinish}
      style={style}
    />
  );
};

export default GraphicProductDataPanel;
